import React, { useContext } from "react";
import { withRouter } from "react-router-dom";

import { MdBookmarkBorder, MdPlaylistAddCheck } from "react-icons/md";
import { GoHome } from "react-icons/go";

import useStyles from "./styles";
import { Context as ViewsContext } from "../../../context/ViewsContext";
import { UserAvatar, List, ListItem } from "../../_common";

const navigationItems = [
  { label: "Campañas", icon: <GoHome /> },
  { label: "Suscripciones", icon: <MdPlaylistAddCheck /> },
  { label: "Me interesan", icon: <MdBookmarkBorder /> },
  { label: "Ajustes y perfil", icon: <UserAvatar size={44} /> }
];

const NavMenu = ({ history, onSubmit }) => {
  const { iconClass, iconClassActive } = useStyles();
  const {
    state: { currentView },
    setView
  } = useContext(ViewsContext);

  return (
    <List>
      {navigationItems.map((e, i) => (
        <ListItem
          key={i}
          title={e.label}
          icon={
            <div
              className={
                currentView === i
                  ? `${iconClass} ${iconClassActive}`
                  : iconClass
              }
            >
              {e.icon}
            </div>
          }
          handleClick={() => {
            history.push("/");
            setView(i);
            onSubmit();
          }}
        />
      ))}
    </List>
  );
};

export default withRouter(NavMenu);
